import { callStartNiceIdentity, callStartNiceIdentityLink } from "api/MuyeonApi";

/**
 * 휴대폰 본인확인(NICE 통합인증) — 표준창 이동/복귀 도우미.
 *
 * ★ 팝업(window.open)이 아니라 **같은 창 이동**이다. 이유:
 *   iOS 웹뷰(CommonWebView.swift 의 createWebViewWith)는 새 창 요청을 받으면 웹뷰를
 *   만들지 않고 `UIApplication.open` 으로 **외부 사파리**를 연다. 표준창이 사파리에서
 *   열리면 인증 후 return_url 도 사파리에 남아 앱으로 결과가 돌아오지 않는다.
 *   카카오 로그인(/oauth/kakao)과 같은 전체 이동 방식으로 맞춘다.
 *
 * ★ 전체 이동이므로 입력 중이던 폼이 날아간다. 떠나기 전에 sessionStorage 에 담아 두고
 *   돌아왔을 때 되살린다(같은 탭이라 sessionStorage 가 유지된다).
 *   ⚠️ **비밀번호는 담지 않는다.** 브라우저 저장소에 평문으로 남기지 않기 위해서다.
 *     그래서 가입 폼에서 본인확인 단계를 비밀번호 입력보다 **앞에** 둔다 — 뒤에 두면
 *     돌아올 때마다 비밀번호를 다시 치게 된다.
 */

const FORM_KEY = "muyeon.identity.form";

/** 인증 결과와 함께 돌아왔을 때 프론트가 받는 쿼리 키. 백엔드 IdentityService.redirect 와 1:1. */
export const NICE_TOKEN_PARAM = "niceToken";
export const NICE_ERROR_PARAM = "niceError";

export const NICE_ERROR_MESSAGE = {
  CANCELLED: "본인인증을 취소했어요. 다시 시도해 주세요.",
  EXPIRED: "본인인증 시간이 지났어요. 다시 시도해 주세요.",
  ALREADY_USED: "이미 사용한 본인인증이에요. 다시 시도해 주세요.",
  NOT_FOUND: "본인인증 요청을 찾지 못했어요. 다시 시도해 주세요.",
  FAILED: "본인인증에 실패했어요. 잠시 후 다시 시도해 주세요.",
};

export const stashIdentityForm = (data) => {
  try { sessionStorage.setItem(FORM_KEY, JSON.stringify(data)); } catch (e) {}
};

export const popIdentityForm = () => {
  try {
    const v = sessionStorage.getItem(FORM_KEY);
    sessionStorage.removeItem(FORM_KEY);
    return v ? JSON.parse(v) : null;
  } catch (e) { return null; }
};

/**
 * 표준창으로 이동한다. 성공하면 이 함수는 돌아오지 않는다(페이지가 바뀐다).
 * @param returnTo 인증 후 돌아올 프론트 경로. 서버가 '/' 로 시작하는 값만 허용한다.
 * @param form     복귀 후 되살릴 입력값.
 */
export async function startIdentityVerification({ returnTo, form, linked = false }) {
  stashIdentityForm(form ?? null);
  try {
    // linked=true 는 이미 로그인한 회원의 본인확인(연결·재인증). 서버가 요청에 회원 id 를 묶는다.
    const { data } = linked
      ? await callStartNiceIdentityLink({ returnTo })
      : await callStartNiceIdentity({ returnTo });
    if (!data?.authUrl) throw new Error("본인인증 창 주소를 받지 못했어요.");
    window.location.href = data.authUrl;
  } catch (e) {
    popIdentityForm(); // 못 떠났으면 담아 둔 값도 치운다(비밀번호를 남기지 않는다)
    throw e;
  }
}
